module.exports = __webpack_public_path__ + "static/media/Aryan-Holding-Group-Logo-Square.68eb6411.png";